exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideMode-loading[data-v-75493719]{height:480px;align-items:stetch;font-weight:700}.slideMode-loading[data-v-75493719],.slideMode-loading_body[data-v-75493719]{width:100%;display:flex;justify-content:center;flex-direction:column}.slideMode-loading_body[data-v-75493719]{height:430px;align-items:center;font-size:14px;color:#56c502;border:1px solid #e5e5e5;border-radius:3px 3px 0 0/3px 3px 0 0}", ""]);

// exports
